var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCrm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_13216_34602)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 3,
    width: 62,
    height: 62,
    rx: 31,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.5312 35.2552C49.5312 34.9361 49.2722 34.6771 48.9531 34.6771H33.3438V19.0469C33.3438 18.7278 33.0847 18.4688 32.7656 18.4688C23.5214 18.4688 16 25.9786 16 35.2101C16 44.7815 23.2185 52 32.7899 52C41.7081 52 49.5312 44.1745 49.5312 35.2552ZM17.1562 35.2101C17.1562 26.9837 23.5717 20.2273 31.6687 19.663C31.9513 19.6433 32.1875 19.8707 32.1875 20.154V35.2552C32.1875 35.5743 32.4465 35.8333 32.7656 35.8125H47.8428C48.1269 35.8125 48.3547 36.0495 48.3329 36.3328C47.7286 44.1906 40.7253 50.8438 32.7899 50.8438C23.8775 50.8438 17.1562 44.1236 17.1562 35.2101Z",
    fill: "#2D53DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.2344 32.3437H52.4207C52.7398 32.3646 53 32.0847 53 31.7656C53 22.5214 45.4786 15 36.2344 15C35.9153 15 35.6562 15.259 35.6562 15.5781V31.7864C35.6562 32.1056 35.9153 32.3646 36.2344 32.3437ZM36.8125 16.6853C36.8125 16.402 37.0486 16.1745 37.3313 16.1943C45.0841 16.7356 51.2957 22.9631 51.811 30.6912C51.8298 30.9732 51.6025 31.2083 51.3198 31.2083H37.3125C37.0364 31.2083 36.8125 30.9845 36.8125 30.7083V16.6853Z",
    fill: "#ED3241"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_13216_34602",
    x: 0,
    y: 0,
    width: 70,
    height: 70,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_13216_34602"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_13216_34602",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrm);
export default __webpack_public_path__ + "static/media/CRM.1edcb5b3ebf3970ec0cfe31935af8c19.svg";
export { ForwardRef as ReactComponent };